import { useState } from "react";
import { OptionItem } from "../components/TextSwitch/TextSwitch";
import { FilterProps } from "../types/AppTypes";
import { PotentialMatrixFilterKeyEnum } from "../types/api/filters.type";
import {
  TypeMatrixEnum,
  typeOptions,
} from "../constants/PotentialMatrixConstants";

export type PotentialMatrixFilters = {
  practice: string[];
  cc: string[];
  type: OptionItem<TypeMatrixEnum>;
  year: number;
  internalGrade: string[];
  hiddenCollaborators: number[];
  collaboratorId: number | null;
};

interface UseMatrixFiltersParams {
  currentYear: number;
  previousYear?: number;
  internalGrade?: string[];
  defaultType?: OptionItem<TypeMatrixEnum>;
  defaultPractice?: string[];
  defaultCompetence?: string[];
}

export const usePotentialMatrixFilters = ({
  currentYear,
  previousYear,
  internalGrade,
  defaultType,
  defaultPractice,
  defaultCompetence,
}: UseMatrixFiltersParams) => {
  const [filters, setFilters] = useState<PotentialMatrixFilters>({
    practice: defaultPractice ?? [],
    cc: defaultCompetence ?? [],
    type:
      (defaultType ?? currentYear === previousYear)
        ? typeOptions[1]
        : typeOptions[0],
    year: currentYear,
    internalGrade: internalGrade ?? [],
    hiddenCollaborators: [],
    collaboratorId: null,
  });

  const handleFilters = (
    key: PotentialMatrixFilterKeyEnum,
    value: PotentialMatrixFilters[PotentialMatrixFilterKeyEnum],
  ) => {
    setFilters((prev) => {
      if (key === PotentialMatrixFilterKeyEnum.YEAR) {
        const yearValue = value;
        const updateType =
          yearValue === previousYear ? typeOptions[1] : typeOptions[0];
        return {
          ...prev,
          year: value as number,
          type: updateType,
        };
      }
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  const createQueryParams = (collaboratorsLimit: number): FilterProps[] => {
    return [
      { key: PotentialMatrixFilterKeyEnum.YEAR, value: [filters.year] },
      { key: PotentialMatrixFilterKeyEnum.TYPE, value: [filters.type.value] },
      {
        key: "collaboratorsLimit",
        value: [filters.collaboratorId ? 1 : collaboratorsLimit],
      },
      ...(filters.practice.length > 0
        ? [
            {
              key: PotentialMatrixFilterKeyEnum.PRACTICE,
              value: filters.practice,
            },
          ]
        : []),
      ...(filters.cc.length > 0
        ? [
            {
              key: PotentialMatrixFilterKeyEnum.COMPETENCE,
              value: filters.cc,
            },
          ]
        : []),
      ...(filters.internalGrade.length > 0 && filters.internalGrade[0] !== "all"
        ? [
            {
              key: PotentialMatrixFilterKeyEnum.INTERNAL_GRADE,
              value: filters.internalGrade,
            },
          ]
        : []),
      ...(filters.hiddenCollaborators.length > 0
        ? [
            {
              key: PotentialMatrixFilterKeyEnum.HIDDEN_COLLABORATORS,
              value: filters.hiddenCollaborators,
            },
          ]
        : []),
      ...(filters.collaboratorId
        ? [
            {
              key: PotentialMatrixFilterKeyEnum.COLLABORATOR_ID,
              value: [filters.collaboratorId],
            },
          ]
        : []),
    ];
  };
  return {
    filters,
    handleFilters,
    createQueryParams,
  };
};
